import { Project } from '../types/project';
import { ProjectInput } from '../types/projectInput';
import { DeleteInput } from '../types/deleteInput';
import { DeleteResult } from '../types/deleteResult';

export interface CreateProjectResponse {
  createProject: Project;
}

export interface CreateProjectVariables {
  input: ProjectInput;
}

export interface DeleteProjectResponse {
  deleteProject: DeleteResult;
}

export interface DeleteProjectVariables {
  input: DeleteInput;
}

export const createProjectMutation = `
  mutation CreateProject($input: ProjectInput!) {
    createProject(input: $input) {
      id
      title
      signatureSecretKey
      jwtSecretKey
      jwtAccessTokenExpiresIn
      jwtRefreshTokenExpiresIn
      baseListingUrl
      chatEnabled
      createdAt
      updatedAt
    }
  }
`;

export const deleteProjectMutation = `
  mutation DeleteProject($input: DeleteInput!) {
    deleteProject(input: $input) {
      success
    }
  }
`;
